import React, { Component } from 'react';

import './home.css';

class Index extends Component {
    
    constructor(){
        super();
        this.state = {
            estilos: {
                position: 'fixed',
                z_index: '12341232',
                bottom: '0', 
                right: '1em'
            }
        };
    }

    render(){
        return(
            <div>
                <img className="img-container" src={require("../../img/Landing.png")} alt="Pablo"/>   
                <iframe height='100%' width='100%' src='https://i-strategies-chatbot-embedded.firebaseapp.com/fc6GTcE6zeTHgy3nEQNz' title='chatBox' style={this.state.estilos} scrolling="no"></iframe>
            </div>
        );
    }
}

export default Index;